import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useCreateAcccessToken = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .post(`${config.appUrls.identity}/api/profile/pats`, Object.assign(Object.assign({}, values), { expires: parseInt(((new Date(values.expires).getTime() - new Date().getTime()) / 1000).toFixed()) }))
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        createAccessToken: mutateAsync,
        isLoading,
        error,
    };
};
